module.exports = __webpack_public_path__ + "static/media/chat-teardrop-dots.94a7bd98.svg";